import { defineStore } from 'pinia'
import axios from 'axios'

export const useMainStore = defineStore('main', {
    state: () => ({
        isAuthenticated: false,
        token: '',
        appLanguage: 'uk',
        user: {
            id: 0,
            username: '',
            permissions: []
        },
        isDarkMode: false,
        viewingUser: null,
    }),
    actions: {
        initializeStore() {
            const token = localStorage.getItem('token')
            if (token) {
                this.token = token
                this.isAuthenticated = true
                this.user.username = localStorage.getItem('username') || ''
                this.user.id = parseInt(localStorage.getItem('userID') || '0', 10)
                try {
                    this.user.permissions = JSON.parse(localStorage.getItem('permissions')) || []
                } catch {
                    this.user.permissions = []
                }
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
            }

            const lang = localStorage.getItem('appLanguage')
            if (lang) {
                this.appLanguage = lang
            }

            this.isDarkMode = localStorage.getItem('isDarkMode') === 'true'
            this.applyTheme()
        },

        toggleDarkMode() {
            this.isDarkMode = !this.isDarkMode
            localStorage.setItem('isDarkMode', this.isDarkMode)
            this.applyTheme()
        },

        applyTheme() {
            if (this.isDarkMode) {
                document.body.classList.add('dark-theme')
            } else {
                document.body.classList.remove('dark-theme')
            }
        },

        setToken(token) {
            this.token = token
            this.isAuthenticated = true
            localStorage.setItem('token', token)
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
        },

        setUser(user) {
            this.user.id = user.id
            this.user.username = user.username
            this.user.permissions = user.permissions || []

            localStorage.setItem('username', user.username)
            localStorage.setItem('userID', user.id)
            localStorage.setItem('permissions', JSON.stringify(this.user.permissions))
        },

        logout() {
            this.token = ''
            this.isAuthenticated = false
            this.user = { id: 0, username: '', permissions: [] }

            localStorage.removeItem('token')
            localStorage.removeItem('username')
            localStorage.removeItem('userID')
            localStorage.removeItem('permissions')

            delete axios.defaults.headers.common['Authorization']
        },

        setAppLanguage(language) {
            this.appLanguage = language
            localStorage.setItem('appLanguage', language)
        },

        async fetchUserPermissions() {
            try {
                const response = await axios.get(`/api/v1/admin/users/${this.user.id}/permissions/`)
                const permissions = response.data.permissions.map(p => 
                    `${p.content_type.app_label}.${p.codename}`
                )
                this.user.permissions = permissions
                localStorage.setItem('permissions', JSON.stringify(permissions))
            } catch (error) {
                console.error('Failed to fetch permissions:', error)
            }
        }
    }
})
